




import Vue from 'vue'
export default Vue.extend({
  props: {
    value: Boolean
  },
  computed: {
    color (): string | undefined {
      if (this.value) { return 'primary' }
      return undefined
    }
  }
})
